import { Badge } from "reactstrap";

import React from "react";
import { BadgeButton } from "../../../../Layout/Components/BadgeButton/BadgeButton";
import { WorkflowState } from "../../../../Workflows/Models/WorkflowState";

type Props = {
  state: WorkflowState;
};

export const FeedbackWorkflowStateBadge: React.FC<Props> = props => {
  return (
    <BadgeButton color={props.state.color} textColor={props.state.backgroundColor} disabled>
      {props.state.name}
    </BadgeButton>
  );
};

export default FeedbackWorkflowStateBadge;
